export default __webpack_public_path__ + "static/media/icon-fourth-wood.e5a6c9ed.svg";